import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import TableTab1 from "./TableTab1";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import {
  usePaymentTermListMutation,
} from "../../../../store/api/itemapi";
const Tab1 = ({
  IdData,
  TemplateName,
  AllocatePaymentBasedOnPaymentTerms,
  setselected_payment_term_data,
  selected_payment_term_data,
  list_payment_term_data,
   pageState,setPageState
}) => {
  const [PaymentTermApi] = usePaymentTermListMutation();
  return (
    <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                 <Input
              id="TemplateName"
              label="Template Name"
              style={{
                height: "30px",
                border: TemplateName.Error ? "1px solid red" : "",
              }}
              value={TemplateName.value}
              onChange={(e) =>
                TemplateName.setValue(e.target.value)
              }
              readOnly
            />
           
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{height: '19px'}}></label>
                   <Checkbox
            id="AllocatePaymentBasedOnPaymentTerms"
            label="Allocate Payment Based On Payment Terms"
            value={AllocatePaymentBasedOnPaymentTerms?.value || false}
            onChange={(val) => AllocatePaymentBasedOnPaymentTerms?.setValue?.(val)}
            
          />
<div style={{ fontSize: "9px", color: "#00000099", marginLeft:'23px' }}>
    If this checkbox is checked, paid amount will be splitted and allocated as per the amounts in payment schedule against each payment term
  </div>
    <div style={{ flex: 1 }}>

    </div>
     <div style={{ flex: 1 }}>
      
    </div>

                </div>
                 <div style={{ flex: 1 }}>
                  
                </div>
                <div style={{ flex: 1 }}>
                  
                </div>
               
              </div>







            </div>
          </div>

        </div>
        <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Payment Terms</p>
                </div>
              </div>
    <TableTab1
  setselected_payment_term_data={{
    value: pageState.selected_payment_term_data || [],
    setValue: (val) =>
      setPageState({
        ...pageState,
        selected_payment_term_data: val,
      }),
  }}
  list_payment_term_data={PaymentTermApi}
/>




              </div>
            </div>

          </div>
   <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <ActivityCard doctype="Payment Terms Template" docname={IdData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  
  );
};

export default Tab1;
